import {Box, Button, Grid, Typography} from "@mui/material";
import {motion} from "framer-motion";
import styles from "../global/header.module.css";
import {fontType} from "../../constants/font";
import {useInView} from "react-intersection-observer";
import voucher50 from "../../assets/vouchers/50.png";
import voucher100 from "../../assets/vouchers/100.png";
import voucher200 from "../../assets/vouchers/200.png";
import React, {useState} from "react";
import VoucherOrderForm from "./VoucherOrderForm";

function Vouchers({
    windowWidth,
}) {
    const [descriptionAnimationRef, inViewDescription] = useInView({
        triggerOnce: true, // Only trigger the animation once when scrolled into view
    });

    const [vouchersAnimationRef, inViewVouchers] = useInView({
        triggerOnce: true, // Only trigger the animation once when scrolled into view
    });

    const vouchers = [
        {price: 50, image: voucher50},
        {price: 100, image: voucher100},
        {price: 200, image: voucher200},
    ];

    const [voucherOrder, setVoucherOrder] = useState(null);

    function openVoucherOrderForm(voucher) {
        setVoucherOrder(voucher);
    }

    function closeVoucherOrderForm() {
        setVoucherOrder(null);
    }

    function renderVouchers() {
        return (
            <>
                {
                    vouchers.map(voucher => {
                        return (
                            <Box
                                sx={{
                                    width: "100%",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    transform: "scale(1)",
                                    transition: "transform 0.3s ease",
                                    "&:hover": {
                                        // Styles on hover
                                        transform: {xs: "scale(1.05)", sm: "scale(1.1)"},
                                    },
                                }}
                            >
                                    <img
                                        src={voucher.image}
                                        alt="50"
                                    />
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: 'center',
                                        flexDirection: "column",
                                    }}
                                >
                                    <Button
                                        onClick={() => openVoucherOrderForm(voucher.price)}
                                        sx={{
                                            borderRadius: "28px",
                                            border: "2px solid",
                                            borderColor: "#7b7cd5",
                                            backgroundColor: "#7b7cd5",
                                            fontFamily: fontType.regular,
                                            fontSize: 16,
                                            cursor: "pointer",
                                            color: "white",
                                            height: "44px",
                                            width: "186px",
                                            textTransform: "initial",
                                            "&:hover": {
                                                backgroundColor: "#1d1a56",
                                                borderColor: "#1d1a56",
                                                color: "white",
                                            },
                                        }}
                                    >
                                        Objednať
                                    </Button>
                                </Box>
                            </Box>
                        )
                    })
                }
            </>
        )
    }

    return (
        <>
            <Box
                id="vouchers"
                sx={{
                    backgroundColor: "#d8d8d8",
                    display: "flex",
                    justifyContent: "center",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        maxWidth: "1440px",
                        width: "100%",
                        position: "relative",
                    }}
                >
                    <motion.div
                        ref={descriptionAnimationRef}
                        initial={{ opacity: 0, y: 50 }}
                        animate={inViewDescription ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                        transition={{ duration: 0.7 }}
                    >
                        <Box
                            sx={{
                                marginTop: { sm: "60px", xs: "35px" },
                                marginBottom: "50px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 2,
                                position: "relative",
                                paddingLeft: windowWidth < 2700 ? {md: "9vw", xs: "0"} : "0",
                                paddingRight: windowWidth < 2700 ? {md: "9vw", xs: "0"} : "0",
                            }}
                        >
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    fontFamily: fontType.semiBold,
                                    fontSize: 38,
                                    color: "#1d1a56",
                                    marginBottom: "15px",
                                    lineHeight: "40px",
                                }}
                            >
                                Darčekové poukazy
                            </Typography>
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    fontFamily: fontType.regular,
                                    fontSize: 22,
                                    lineHeight: "28px",
                                    color: "#1d1a56",
                                }}
                            >
                                Vyberte si kurz a urobte radosť niekomu blízkemu.
                            </Typography>
                        </Box>
                    </motion.div>
                    <motion.div
                        ref={vouchersAnimationRef}
                        initial={{ opacity: 0, y: 50 }}
                        animate={inViewVouchers ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                        transition={{ duration: 0.7 }}
                    >
                        <Grid
                            container
                            sx={{
                                paddingLeft: windowWidth < 2700 ? {md: "9vw", xs: "0"} : "0",
                                paddingRight: windowWidth < 2700 ? {md: "9vw", xs: "0"} : "0",
                                position: "relative",
                                zIndex: 2,
                                display: "flex",
                                justifyContent: { lg: "center", xs: "center" },
                                alignItems: "center",
                                gap: "50px",
                                marginBottom: "60px",
                            }}
                        >
                            {renderVouchers()}
                        </Grid>
                    </motion.div>
                    <img
                        className={styles.element}
                        style={{
                            position: "absolute",
                            top: 100,
                            zIndex: 1,
                        }}
                        src={require("../../assets/elements2.png")}
                        alt="academy_logo"
                    />
                    <div
                        style={{
                            position: "absolute",
                            bottom: 100,
                            zIndex: 1,
                            transform: "scaleX(-1)",
                        }}
                    >
                        <img className={styles.element} src={require("../../assets/elements2.png")} alt="academy_logo_bottom" />
                    </div>
                </Box>
            </Box>
            {voucherOrder && <VoucherOrderForm voucher={voucherOrder} onCloseHandler={closeVoucherOrderForm} />}
        </>
    )
}

export default Vouchers;